export const BANK_ADD = '/bank-add';
